const VERSION_CHECK_INTERVAL_MS = 4 * 60 * 60 * 1000;
const LAST_VERSION_CHECK_KEY = "wallet-watch:last-version-check-at";

const APP_BUILD_ID = __APP_BUILD_ID__;

function readStorageNumber(key) {
  try {
    const rawValue = window.localStorage.getItem(key);
    const parsed = Number(rawValue);
    return Number.isFinite(parsed) ? parsed : 0;
  } catch {
    return 0;
  }
}

function writeStorageNumber(key, value) {
  try {
    window.localStorage.setItem(key, String(value));
  } catch {
    // ignore storage failures
  }
}

export async function checkForAppUpdate({ now = Date.now(), force = false } = {}) {
  if (!force) {
    const lastCheckAt = readStorageNumber(LAST_VERSION_CHECK_KEY);
    if (lastCheckAt > 0 && now - lastCheckAt < VERSION_CHECK_INTERVAL_MS) {
      return {
        checked: false,
        updateAvailable: false,
        buildId: APP_BUILD_ID
      };
    }
  }

  writeStorageNumber(LAST_VERSION_CHECK_KEY, now);

  try {
    const response = await fetch(`${import.meta.env.BASE_URL}version.json`, {
      cache: "no-store"
    });

    if (!response.ok) {
      return {
        checked: true,
        updateAvailable: false,
        buildId: APP_BUILD_ID
      };
    }

    const payload = await response.json();
    const remoteBuildId = String(payload?.buildId ?? "").trim();

    return {
      checked: true,
      updateAvailable: Boolean(remoteBuildId) && remoteBuildId !== APP_BUILD_ID,
      buildId: remoteBuildId || APP_BUILD_ID
    };
  } catch {
    return {
      checked: true,
      updateAvailable: false,
      buildId: APP_BUILD_ID
    };
  }
}
